import { Component, Injector } from '@angular/core';
import { RsfMainSBaseComponent } from '../../rsf-main-s-base/rsf-main-s-base.component';
import { OLogService } from 'src/app/components/olog/olog.service';
import { FormType, OlogNotificationType } from 'src/app/common/enumerations/enumerations';
import { PartialOlogComponent } from 'src/app/components/olog/partial-olog/partial-olog.component';

@Component({
  selector: 'rsf-olog-dialog',
  templateUrl: './rsf-olog-dialog.component.html',
  styleUrls: ['./rsf-olog-dialog.component.scss']
})
export class RsfOlogDialogComponent extends RsfMainSBaseComponent {

  constructor(
    protected override injector: Injector,
    private ologService: OLogService,
  ) {
    super(injector);
  }

  async editOlog() {
    if (this.rsf?.id) {
      try {
        const data = await this.ologService
          .getOlog(
            FormType.RSF,
            this.rsf.id,
            OlogNotificationType.Activate
          )
          .toPromise();
        if (data) {
          const dialogRef = this.dialog.open(PartialOlogComponent, {
            height: 'fit-content',
            width: '80%',
            data,
          });
          dialogRef.afterClosed().subscribe((isSaved) => {
            console.log('The dialog was closed');
            if (isSaved) {
              console.log(isSaved);
            }
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  }

}
